import React, { createContext, useContext } from 'react';

const ProfileContext = createContext({
    profileData: null,
    profileLoading: false,
    refreshProfileData: () => { },
    setProfileData: () => { },
});

export const useProfile = () => useContext(ProfileContext);

export default ProfileContext;
